import * as React from "react"
import {SVGProps} from "react";

const AbusingWorksheet = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        width={260}
        height={160}
        {...props}
    >
        <defs>
            <clipPath id="clippath">
                <path
                    d="M139.16 69.99c-9.24-7.59-21.19-11.89-34.05-11.26-12.86.62-24.35 6.08-32.8 14.51-9.23 9.24-14.83 22.02-14.61 36 .02.92.82 1.65 1.74 1.6l20.82-1.01c.85-.04 1.57-.73 1.57-1.6.07-7.23 3.14-13.81 8.07-18.44a25.61 25.61 0 0 1 16.39-6.98c6.37-.31 12.33 1.73 17 5.35 5.36 4.15 9.06 10.38 9.82 17.57.08.86.87 1.48 1.72 1.44l20.82-1.01c.92-.04 1.65-.85 1.57-1.76-1.14-13.94-7.96-26.13-18.05-34.42Z"
                    className="cls-30"
                />
            </clipPath>
            <clipPath id="clippath-1">
                <rect
                    width={50.82}
                    height={5.6}
                    x={82.96}
                    y={123.07}
                    rx={2.8}
                    ry={2.8}
                    style={{
                        fill: "#292561",
                        strokeWidth: 0,
                    }}
                    transform="rotate(-2.78 108.287 125.718)"
                />
            </clipPath>
            <clipPath id="clippath-2">
                <circle
                    cx={154.6}
                    cy={113.07}
                    r={2.89}
                    style={{
                        fill: "#6ebde4",
                        strokeWidth: 0,
                    }}
                />
            </clipPath>
            <style>
                {
                    ".cls-1{fill:#e4e4e4}.cls-1,.cls-10,.cls-12,.cls-13,.cls-15,.cls-16,.cls-19,.cls-20,.cls-21,.cls-24,.cls-27,.cls-3,.cls-4,.cls-6,.cls-9{stroke-width:0}.cls-3{fill:#ffd100}.cls-30{stroke:#e5e1e6;stroke-width:2.14px;stroke-miterlimit:10}.cls-30,.cls-32,.cls-33,.cls-34{fill:none}.cls-4{fill:#f7941e}.cls-36{opacity:.2}.cls-9{fill:#c77616}.cls-10{fill:#db7e21}.cls-12{fill:#e7c9c0}.cls-32,.cls-33,.cls-34{stroke-linecap:round}.cls-32{stroke:#ffd100;stroke-width:2px}.cls-32,.cls-33,.cls-34{stroke-linejoin:round}.cls-13{fill:#6280b2}.cls-15{fill:#fff}.cls-16{fill:#793a25}.cls-19{fill:#f3d7cd}.cls-20{fill:#2aa3db}.cls-21{fill:#231f20}.cls-33{stroke:#fff;stroke-width:3.49px;opacity:.3}.cls-24{fill:#2e2c74}.cls-34{stroke:#e4e4e4;stroke-width:13.02px}.cls-27{fill:#2591b7}"
                }
            </style>
        </defs>
        <path
            d="M131.48 61.17c.69.68 1.83.65 2.54-.07l4.14-4.2c.71-.72.73-1.86.03-2.54-.69-.68-1.83-.65-2.54.07l-4.14 4.2c-.71.72-.73 1.86-.03 2.54Z"
            className="cls-4"
        />
        <circle cx={177.63} cy={36.04} r={33.56} className="cls-4" />
        <path
            d="m185.65 18.5-2.25-.87c-9.85-3.84-20.54-.22-24.38 9.63l-7.61 19.53c-.62 1.59.17 3.39 1.76 4.01l32.29 12.58c1.59.62 3.39-.17 4.01-1.76l7.1-18.23c3.84-9.85-1.08-21.05-10.93-24.88Z"
            className="cls-16"
        />
        <path
            d="M161.74 43.43a6.333 6.333 0 0 1-8.22 3.52 6.333 6.333 0 0 1-3.52-8.22 6.333 6.333 0 0 1 8.22-3.52 6.333 6.333 0 0 1 3.52 8.22M196.11 56.81c-1.3 3.24-4.98 4.82-8.22 3.52-3.24-1.3-4.82-4.98-3.52-8.22 1.3-3.24 4.98-4.82 8.22-3.52a6.333 6.333 0 0 1 3.52 8.22"
            className="cls-19"
        />
        <path
            d="m185.65 18.5-2.25-.87c-9.85-3.84-20.54-.22-24.38 9.63l-3.47 8.91c-.62 1.59.17 3.39 1.76 4.01l32.29 12.58c1.59.62 3.39-.17 4.01-1.76l2.97-7.61c3.84-9.85-1.08-21.05-10.93-24.88Z"
            className="cls-16"
        />
        <path
            d="m173.33 61.23-9.67-3.77-3.19 8.18h.02-.02c-.88 2.25.34 4.83 2.72 5.76l1.05.41c2.38.93 5.02-.15 5.9-2.4l3.19-8.18Z"
            style={{
                fill: "#e19b7c",
                strokeWidth: 0,
            }}
        />
        <rect
            width={36.94}
            height={47.46}
            x={156.79}
            y={18.11}
            className="cls-19"
            rx={17.69}
            ry={17.69}
            transform="rotate(21.28 175.28 41.852)"
        />
        <rect
            width={4.28}
            height={5.5}
            x={164.3}
            y={38.95}
            className="cls-21"
            rx={2.14}
            ry={2.14}
            transform="rotate(21.28 166.465 41.717)"
        />
        <rect
            width={4.28}
            height={5.5}
            x={179.71}
            y={44.95}
            className="cls-21"
            rx={2.14}
            ry={2.14}
            transform="rotate(-158.72 181.852 47.707)"
        />
        <rect
            id="Nose"
            width={2.84}
            height={4.58}
            x={171.47}
            y={45.63}
            rx={1}
            ry={1}
            style={{
                fill: "#f3b79d",
                strokeWidth: 0,
            }}
            transform="rotate(-68.72 172.89 47.92)"
        />
        <ellipse
            cx={158.77}
            cy={45.81}
            className="cls-12"
            rx={1.74}
            ry={2.26}
            transform="rotate(-68.72 158.763 45.807)"
        />
        <ellipse
            cx={184.76}
            cy={55.93}
            className="cls-12"
            rx={1.74}
            ry={2.26}
            transform="rotate(-68.72 184.752 55.935)"
        />
        <path
            id="Eyebrows"
            d="M173.37 54.38c-1.6.57-4.26-.45-5.12-2"
            style={{
                strokeLinecap: "round",
                stroke: "#231f20",
                strokeWidth: "1.63px",
                fill: "none",
                strokeMiterlimit: 10,
            }}
        />
        <rect
            width={1.58}
            height={1.23}
            x={165.26}
            y={40.18}
            className="cls-15"
            rx={0.61}
            ry={0.61}
            transform="rotate(-68.72 166.038 40.8)"
        />
        <rect
            width={1.58}
            height={1.23}
            x={180.88}
            y={46.27}
            className="cls-15"
            rx={0.61}
            ry={0.61}
            transform="rotate(-68.72 181.664 46.89)"
        />
        <circle cx={173.2} cy={77.45} r={6.55} className="cls-1" />
        <circle cx={152.85} cy={69.52} r={6.55} className="cls-1" />
        <path
            d="m152.85 69.52-18.86 4.76-4.48-11.95M173.2 77.45l10.2 16.18 6.95-10.08"
            className="cls-34"
        />
        <path
            d="M179.3 79.98a6.79 6.79 0 0 0-3.86-8.79c-5.81-2.26-14.23-5.54-20.02-7.79a6.793 6.793 0 0 0-8.79 3.86c-4.68 12.01-10.09 24-10.09 24l-4.01 10.3c-1.8 4.61 31.96 17.76 33.76 13.15l4.01-10.3s4.34-12.45 9.01-24.43Z"
            className="cls-1"
        />
        <path
            d="M168.57 107.89a166.13 166.13 0 0 1-33.21-12.92c-.4-.15-.6-.59-.45-.98l2.47-5.71c.15-.38.59-.57.99-.41 10.72 4.78 21.64 9.03 32.78 12.75.4.15.6.59.45.98l-2.04 5.88c-.15.38-.59.57-.99.41Z"
            className="cls-4"
        />
        <rect
            width={9.68}
            height={9.66}
            x={148.35}
            y={93.45}
            rx={2.36}
            ry={2.36}
            style={{
                fill: "#ffa452",
                strokeWidth: 0,
            }}
            transform="rotate(21.27 153.2 98.285)"
        />
        <path
            d="M197.56 32.95c-.52-2.89-1.73-5.25-3.1-7.47-1.99-2.92-5.16-5.55-8.55-6.88l-2.3-.9c-5.91-2.3-12.67-2.02-17.53 1.01-4.62 2.88-6.03 5.93-7.63 10.02l-.36.92 3.25 1.27c3.85 1.5 8.19-.41 9.69-4.26l-.02.06a7.42 7.42 0 0 0 4.22 9.61l20.92 8.15.51-1.31c1.37-3.5 1.46-7.15.9-10.23Z"
            className="cls-16"
        />
        <path
            d="M169.66 11.46c4.56-1.48 9.65-1.45 14.47.43h0M159 19.07c.82-1.1 1.73-2.11 2.73-3.01.91-.83 1.88-1.57 2.91-2.23"
            className="cls-33"
        />
        <circle
            cx={177.36}
            cy={36.45}
            r={30}
            style={{
                opacity: 0.3,
                fill: "#fff",
                strokeWidth: 0,
            }}
        />
        <rect
            width={14.97}
            height={5.14}
            x={202.71}
            y={46.68}
            className="cls-9"
            rx={2.57}
            ry={2.57}
            transform="rotate(111.28 210.2 49.252)"
        />
        <rect
            width={14.97}
            height={5.14}
            x={137.23}
            y={21.17}
            className="cls-9"
            rx={2.57}
            ry={2.57}
            transform="rotate(111.28 144.716 23.742)"
        />
        <path
            d="m156.337 59.93 20.826 8.111a1.451 1.451 0 0 1 .825 1.877l-.24.615a1.451 1.451 0 0 1-1.877.825l-20.21-7.871a2.11 2.11 0 0 1-1.201-2.732 1.451 1.451 0 0 1 1.877-.825Z"
            className="cls-9"
        />
        <path
            d="m51.15 133.37 3.06 6.34-.28-5.63-2.78-.71zM166.07 127.8l-2.43 6.61-.28-5.64 2.71-.97z"
            className="cls-24"
        />
        <path
            d="M105.054 57.35c30.354-1.473 56.201 21.97 57.676 52.335l1.124 23.152a4.264 4.264 0 0 1-4.048 4.462l-101.49 4.928a4.264 4.264 0 0 1-4.462-4.048l-1.125-23.153C51.255 84.672 74.7 58.824 105.064 57.35Z"
            className="cls-24"
        />
        <path
            d="M105.68 50.81h2.1c31.36 0 56.82 25.46 56.82 56.82v21.29a4.4 4.4 0 0 1-4.4 4.4H53.27a4.4 4.4 0 0 1-4.4-4.4v-21.29c0-31.36 25.46-56.82 56.82-56.82Z"
            style={{
                fill: "#3f3a92",
                strokeWidth: 0,
            }}
            transform="rotate(-2.78 106.634 91.864)"
        />
        <path
            d="M105.62 92.57c-6.7 1.11-11.2 7.41-10.09 14.11 1.11 6.7 7.41 11.18 14.12 10.09 6.69-1.14 11.19-7.42 10.08-14.11a12.251 12.251 0 0 0-14.11-10.1Z"
            style={{
                fill: "#2695bc",
                strokeWidth: 0,
            }}
        />
        <path
            d="M157.21 104.41c.07.92-.66 1.72-1.57 1.76l-20.82 1.01c-.85.04-1.63-.58-1.72-1.44a25.602 25.602 0 0 0-9.82-17.57L139.16 70c10.08 8.27 16.91 20.47 18.05 34.4Z"
            style={{
                fill: "#dc3735",
                strokeWidth: 0,
            }}
        />
        <path
            d="m139.16 69.99-15.88 18.18a25.649 25.649 0 0 0-17-5.35c-6.36.31-12.08 2.9-16.39 6.98L72.32 73.26h-.01c8.45-8.44 19.94-13.9 32.8-14.52 12.86-.62 24.81 3.68 34.05 11.26Z"
            className="cls-3"
        />
        <path
            d="M89.89 89.79a25.525 25.525 0 0 0-8.07 18.44c0 .86-.72 1.56-1.57 1.6l-20.82 1.01c-.92.04-1.72-.68-1.74-1.6-.22-13.98 5.38-26.77 14.61-36h.01l17.57 16.55Z"
            style={{
                fill: "#a0b84b",
                strokeWidth: 0,
            }}
        />
        <g
            className="cls-36"
            style={{
                clipPath: "url(#clippath)",
            }}
        >
            <path
                d="M156.08 104.37C147.95 54.81 84.05 44.68 63.11 91c-2.55 5.66-3.87 11.9-4.29 18.09h-.28c-.52-19.12 10.83-37.92 28.22-46.01 23.95-11.63 53.16-.76 64.61 23.05 2.79 5.69 4.48 11.9 4.99 18.21l-.28.02Z"
                className="cls-6"
            />
        </g>
        <path
            d="M139.16 69.99c-9.24-7.59-21.19-11.89-34.05-11.26-12.86.62-24.35 6.08-32.8 14.51-9.23 9.24-14.83 22.02-14.61 36 .02.92.82 1.65 1.74 1.6l20.82-1.01c.85-.04 1.57-.73 1.57-1.6.07-7.23 3.14-13.81 8.07-18.44a25.61 25.61 0 0 1 16.39-6.98c6.37-.31 12.33 1.73 17 5.35 5.36 4.15 9.06 10.38 9.82 17.57.08.86.87 1.48 1.72 1.44l20.82-1.01c.92-.04 1.65-.85 1.57-1.76-1.14-13.94-7.96-26.13-18.05-34.42Z"
            className="cls-30"
        />
        <path
            d="m134.05 83.11 3.69-2.82c.33-.26.63-.22.89.12l.39.51c.25.33.21.62-.13.87l-.08.06-.12.08v.02c.83-.06 1.45.2 1.89.77.48.63.55 1.27.21 1.92v.02c.33-.03.68.02 1.04.18.36.15.67.39.92.72.35.46.5.94.43 1.43s-.41.97-1.02 1.44l-2.54 1.94c-.33.26-.63.22-.88-.12l-.44-.57c-.26-.33-.22-.63.12-.88l2.28-1.74c.4-.3.5-.57.31-.82-.24-.32-.55-.44-.92-.39-.37.06-.76.24-1.15.54l-1.49 1.14c-.33.26-.63.22-.88-.12l-.44-.57c-.26-.33-.22-.63.12-.89l2.28-1.74c.4-.3.5-.57.31-.82-.25-.33-.56-.46-.93-.39s-.75.25-1.14.55l-1.49 1.14c-.33.26-.63.21-.88-.12l-.44-.57c-.26-.33-.22-.63.12-.89ZM140.61 90.72c.35-.13.69-.15 1.02-.06.33.1.62.28.88.54.26.27.48.56.67.88.19.32.36.67.5 1.04l.06.16.1-.04c.41-.16.51-.49.31-1.02-.12-.31-.33-.61-.63-.9-.3-.31-.31-.6-.04-.89l.22-.23c.29-.31.59-.33.88-.07.52.51.9 1.08 1.14 1.69.29.77.32 1.44.09 2.04-.23.59-.7 1.02-1.4 1.29l-2.81 1.07c-.39.15-.66.03-.81-.36l-.2-.52c-.15-.39-.02-.67.38-.82l.04-.02.11-.03v-.02s-.07-.02-.12-.03c-.05-.01-.15-.05-.29-.11-.14-.06-.27-.13-.39-.22s-.25-.21-.38-.38c-.14-.17-.24-.35-.32-.56-.2-.53-.2-1.02-.01-1.48s.53-.78 1.01-.96Zm.87 1.77c-.14.05-.23.14-.28.27a.61.61 0 0 0 .01.44c.1.26.29.44.56.55.28.11.54.11.77.02l.15-.06-.06-.17c-.13-.34-.3-.62-.5-.85-.2-.22-.42-.29-.65-.2ZM141.97 97.11l2.38.97 1.94-1.79c.19-.17.36-.23.52-.18.16.05.26.21.3.46l.14.8c.06.33-.05.6-.32.81l-.77.56-.35.25v.02c.18.05.31.08.42.11l.92.25c.33.1.52.32.58.65l.14.8c.05.26 0 .44-.12.54s-.31.11-.55.01l-2.44-1-1.89 1.74c-.19.17-.36.23-.52.18-.16-.05-.26-.21-.31-.46l-.14-.76a.78.78 0 0 1 .31-.81l.79-.62.27-.19v-.02c-.14-.03-.25-.06-.32-.08l-.95-.3a.809.809 0 0 1-.57-.65l-.14-.76c-.05-.26 0-.44.12-.54.13-.1.31-.11.55 0Z"
            className="cls-15"
        />
        <g className="cls-36">
            <path
                d="M108.95 106.91c-1.16.5-3.57-5.11-2.4-5.61l25.62-11.12c1.55-.67 3.35.04 4.02 1.6.66 1.54-.05 3.33-1.59 4l-25.65 11.13Z"
                className="cls-6"
            />
        </g>
        <path
            d="M109.02 105.57c-1.16.5-3.57-5.11-2.4-5.61l25.62-11.12c1.55-.67 3.35.04 4.02 1.6.66 1.54-.05 3.33-1.59 4l-25.65 11.13Z"
            style={{
                fill: "#ff0",
                strokeWidth: 0,
            }}
        />
        <path
            d="M105.62 90.73c-6.7 1.11-11.2 7.41-10.09 14.11 1.11 6.7 7.41 11.18 14.12 10.09 6.69-1.14 11.19-7.42 10.08-14.11a12.251 12.251 0 0 0-14.11-10.1Z"
            className="cls-20"
        />
        <path
            d="M116.2 101.82c-.1.47-.38.79-.83.94-.66.22-1.37-.18-1.55-.83-.05-.2-.07-.41-.13-.61-.11-.44-.27-.85-.47-1.26a6 6 0 0 0-1.39-1.81 6.163 6.163 0 0 0-4.34-1.57c-.23 0-.46.03-.68.07-.34.06-.66.01-.95-.17-.24-.16-.4-.37-.5-.64-.22-.65.16-1.38.83-1.56.07-.02.14-.04.21-.05 1.2-.18 2.38-.12 3.55.2.72.2 1.41.48 2.06.86.92.53 1.71 1.21 2.39 2.03.6.73 1.06 1.54 1.39 2.42.15.41.27.82.36 1.24.05.25.11.49.06.74Z"
            className="cls-15"
        />
        <rect
            width={50.82}
            height={5.6}
            x={82.96}
            y={123.07}
            rx={2.8}
            ry={2.8}
            style={{
                fill: "#292561",
            }}
            transform="rotate(-2.78 108.287 125.718)"
        />
        <g
            style={{
                clipPath: "url(#clippath-1)",
            }}
        >
            <rect
                width={48.06}
                height={5.12}
                x={84.31}
                y={125.68}
                rx={2.56}
                ry={2.56}
                style={{
                    fill: "#212154",
                    strokeWidth: 0,
                }}
                transform="rotate(-2.78 108.232 127.984)"
            />
        </g>
        <rect
            width={8.34}
            height={5.78}
            x={61.66}
            y={115.15}
            className="cls-27"
            rx={1.57}
            ry={1.57}
            transform="rotate(-2.78 65.798 117.883)"
        />
        <rect
            width={6.22}
            height={5.78}
            x={71.01}
            y={114.75}
            className="cls-27"
            rx={1.7}
            ry={1.7}
            transform="rotate(-2.78 74.055 117.464)"
        />
        <rect
            width={15.57}
            height={5.78}
            x={134.67}
            y={111.53}
            className="cls-10"
            rx={1.77}
            ry={1.77}
            transform="rotate(-2.78 142.175 114.169)"
        />
        <circle cx={154.64} cy={113.83} r={2.89} className="cls-20" />
        <rect
            width={15.57}
            height={5.78}
            x={134.63}
            y={110.71}
            rx={1.77}
            ry={1.77}
            style={{
                fill: "#f18f22",
                strokeWidth: 0,
            }}
            transform="rotate(-2.78 142.19 113.55)"
        />
        <rect
            width={14.1}
            height={4.89}
            x={135.37}
            y={111.16}
            rx={1.55}
            ry={1.55}
            style={{
                fill: "#ffa943",
                strokeWidth: 0,
            }}
            transform="rotate(-2.78 142.19 113.55)"
        />
        <g className="cls-36">
            <path
                d="M135.32 113.05c-.04-.67.4-1.34 1.04-1.55.55-.16 1.4-.11 1.98-.16l3.96-.2 3.96-.18c.58 0 1.42-.14 1.98-.03.65.15 1.22.81 1.17 1.46-.1-.65-.59-1.21-1.21-1.3-3.25.15-6.57.48-9.85.5-.53.03-1.44-.04-1.93.08-.67.16-1 .79-1.1 1.39Z"
                className="cls-6"
            />
        </g>
        <path
            d="M147.323 113.939a.39.39 0 0 1 .409.37l.071 1.469-.78.037-.07-1.468a.39.39 0 0 1 .37-.408Z"
            className="cls-10"
        />
        <path d="m151.725 113.198 5.774-.28.035.719-5.774.28z" className="cls-20" />
        <circle
            cx={154.6}
            cy={113.07}
            r={2.89}
            style={{
                fill: "#6ebde4",
            }}
        />
        <rect
            width={0.78}
            height={2.3}
            x={155.74}
            y={113.29}
            className="cls-20"
            rx={0.39}
            ry={0.39}
            style={{
                clipPath: "url(#clippath-2)",
            }}
            transform="rotate(-48.14 156.147 114.448)"
        />
        <rect
            width={8.34}
            height={5.78}
            x={61.62}
            y={114.43}
            className="cls-20"
            rx={1.57}
            ry={1.57}
            transform="rotate(-2.78 65.607 117.26)"
        />
        <rect
            width={6.22}
            height={5.78}
            x={70.98}
            y={114.03}
            className="cls-20"
            rx={1.7}
            ry={1.7}
            transform="rotate(-2.78 74.07 116.846)"
        />
        <path
            d="M131.1 126.8c.8.12 1.51.58 1.93 1.27 4.06 6.65 7.77 16.21 8.71 25.56.11 2.27-63.77 5.37-63.88 3.1.03-9.33 2.77-19.12 6.13-26.12.37-.78 1.07-1.36 1.92-1.53 7.3-1.51 37.79-3.36 45.19-2.28Z"
            style={{
                fill: "#e6e6e6",
            }}
        />
        <path
            d="M134.21 149.24c-16.72 1.48-32.97 2.32-48.74 2.36-.61 0-1.1-.54-1.06-1.17l.12-2.12c.04-.56.48-1 1.03-1.01 15.76-.3 32.21-1.1 48.16-2.34.54-.04 1.02.34 1.12.89l.34 2.1c.11.63-.33 1.23-.95 1.29ZM130.48 133.48c-14.86.91-29.29 1.68-43.31 2.1-.55.02-.98-.48-.94-1.04l.48-1.94c.03-.5.43-.85.91-.9 14-1.35 27.99-2.06 42.16-2.01.48 0 .9.3.99.79l.56 1.87c.1.56-.29 1.11-.84 1.14ZM126.01 142.91a345.496 345.496 0 0 1-33.57 1.54c-.57 0-1.02-.59-1-1.27l.08-2.36c.02-.62.43-1.11.95-1.12 10.79-.16 22.03-.7 32.93-1.6.49-.04.94.37 1.04.96l.44 2.43c.13.7-.28 1.38-.87 1.43Z"
            className="cls-13"
        />
        <rect
            width={12.1}
            height={5.38}
            x={122.63}
            y={51.74}
            className="cls-4"
            rx={2.69}
            ry={2.69}
            transform="rotate(18.64 128.706 54.467)"
        />
        <circle cx={194.59} cy={79.52} r={5.85} className="cls-4" />
        <rect
            width={12.15}
            height={3.68}
            x={189.74}
            y={72.16}
            className="cls-4"
            rx={1.84}
            ry={1.84}
            transform="rotate(-43.55 195.797 74.005)"
        />
        <path
            d="M188.76 79.11s-.05-3.3 1.06-4.81c1.47-1.99 3.45-.47 3.45-.47l-4.51 5.28Z"
            className="cls-4"
        />
        <path
            d="M204.04 70.66c-.02 1.28-.4 2.28-1.06 3.07M205.92 74.21c-.47 1.16-1.17 1.95-2.04 2.44"
            className="cls-32"
        />
        <path
            d="m43.34 42.78 6.5-3.24c.85-.42 1.85.14 1.94 1.08l.78 8.42c.08.88.97 1.44 1.8 1.14l3.15-1.15c.92-.33 1.88.39 1.8 1.37l-1.02 12.74c-.07.82-1.19.99-1.5.23l-2.75-6.77c-.26-.65-.98-.98-1.64-.78l-5.84 1.81c-.77.24-1.58-.25-1.72-1.04l-2.23-12.37c-.11-.59.19-1.17.72-1.44ZM34.21 67.79l1.72-4.85a.95.95 0 0 1 1.52-.4l4.54 3.92c.47.41 1.2.26 1.48-.3l1.05-2.14a.955.955 0 0 1 1.59-.19l5.75 7c.37.45-.12 1.09-.65.85l-4.73-2.11a.956.956 0 0 0-1.22.41l-2.09 3.8c-.28.5-.93.65-1.39.31l-7.22-5.22a.958.958 0 0 1-.34-1.09Z"
            className="cls-3"
        />
        <rect
            width={10.45}
            height={3.72}
            x={219.54}
            y={71.79}
            className="cls-3"
            rx={1.86}
            ry={1.86}
            transform="rotate(92.1 224.772 73.661)"
        />
        <rect
            width={10.45}
            height={3.72}
            x={219.54}
            y={71.79}
            className="cls-3"
            rx={1.86}
            ry={1.86}
            transform="rotate(-177.9 224.765 73.662)"
        />
        <rect
            width={11.41}
            height={4.06}
            x={87.42}
            y={22.73}
            className="cls-3"
            rx={2.03}
            ry={2.03}
            transform="rotate(84.41 93.125 24.764)"
        />
        <rect
            width={11.41}
            height={4.06}
            x={87.42}
            y={22.73}
            className="cls-3"
            rx={2.03}
            ry={2.03}
            transform="rotate(174.41 93.126 24.76)"
        />
        <circle cx={187.15} cy={134.41} r={3.03} className="cls-3" />
        <circle cx={34.16} cy={139.71} r={4.15} className="cls-3" />
    </svg>
)
export default AbusingWorksheet
